import { Link, Navigate } from "react-router-dom";
import SideNav from "../../../../components/dashboard/Sidebar";
import { connect } from "react-redux";
import {
  get_shipping_list,
  get_shipping_list_page,
} from "../../../../redux/actions/shipping";
import { useEffect } from "react";
import { IconPencil, IconPlus } from "@tabler/icons-react";
import SetPagination from "../../../../components/pagination/SetPagination";

function DashboardShipping({
  isAuthenticated,
  get_shipping_list,
  get_shipping_list_page,
  shipping,
  count,
}) {
  useEffect(() => {
    if (isAuthenticated) {
      get_shipping_list();
    }
  }, [isAuthenticated, get_shipping_list]);

  if (!isAuthenticated) return <Navigate to="/" />;

  return (
    <SideNav>
      <div className="container mx-auto px-4 sm:px-8">
        <div className="flex justify-between items-center mt-4">
          <h1 className="text-2xl font-semibold text-gray-900">
            Tiempos de Envío
          </h1>
          <Link
            to="/add-shipping"
            className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            <IconPlus className="h-5 w-5 mr-2" />
            Agregar Envío
          </Link>
        </div>
        <div className="mt-8">
          <div className="flex flex-col">
            <div className="overflow-x-auto sm:-mx-6 lg:-mx-8">
              <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                  <table className="min-w-full divide-y divide-gray-200 text-center">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Nombre del Envío
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Precio
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Tiempo de Entrega
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Fecha de Creación
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          Acciones
                        </th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {shipping &&
                        shipping.map((item) => (
                          <tr key={item.id}>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {item.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              ${parseFloat(item.price).toFixed(2)}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {item.time_to_delivery}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {new Date(item.created_at).toLocaleDateString(
                                "es-ES",
                                {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                },
                              )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              <div className="flex tooltip" data-tip="Editar">
                                <Link
                                  to={`/edit-shipping/${item.id}`}
                                  className="p-1 text-white bg-yellow-500 rounded-full"
                                >
                                  <IconPencil />
                                </Link>
                              </div>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
                <SetPagination
                  list_page={get_shipping_list_page}
                  count={count}
                  type="medium"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </SideNav>
  );
}

const mapStateToProps = (state) => ({
  isAuthenticated: state.Auth.isAuthenticated,
  shipping: state.ShippingFull.shippings,
  count: state.ShippingFull.count,
});

export default connect(mapStateToProps, {
  get_shipping_list,
  get_shipping_list_page,
})(DashboardShipping);
